import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useBeforeUnload } from 'react-use';

export const Route = createFileRoute('/arc/_sip/call')({
  component: CallLayout,
});

// calling related pages, not permitting refresh
function CallLayout() {
  useBeforeUnload(
    true,
    'You may lose unsaved work. Are you sure you want to leave?',
  );

  return (
    <>
      <Outlet />
    </>
  );
}
